<template>
	<div class="grid p-fluid">
		<template v-if="loader==true">
			<div class="col-12 mb-2 lg:col-12">
			<ProgressBar mode="indeterminate" style="height: .5em;" />
			</div>
		</template>
		
		<template v-if="selectgenerador==null">
			
		
				<div class="col-12 md:col-6 lg:col-2 mt-1">
					<div class="card overview-box flex flex-column pt-2 bg-white border-blue-900 border-solid solid-blue-900-text-color text-blue-900">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">TOTAL</h6>
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column" >
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{suma_cartera(totales_cartera)}}</span>
								<span class=" fs-large">${{new Intl.NumberFormat().format(suma_cartera_valor(totales_cartera))}}</span>
							</div>
							<div class="flex align-items-end">
							
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 md:col-6 lg:col-2 mt-1">
					<div class="card overview-box flex flex-column pt-2 purple-bgcolor solid-surface-text-color" style="background-color: #77bf62 !important;">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">SIN VENCER</h6>
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column" >
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{totales_cartera.suma_total_modulo_sin_vencer ?? 0}}</span>
								<span class="mb-1 fs-large">${{new Intl.NumberFormat().format(totales_cartera.suma_total_valor_modulo_sin_vencer ?? 0)}}</span>
							</div>
							<div class="flex align-items-end">
							
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 md:col-6 lg:col-2 mt-1">
					<div class="card overview-box flex flex-column pt-2 blue-bgcolor solid-surface-text-color" style="background-color: #429ce5 !important;">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">0 - 30 DIAS</h6>
							
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column">
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{totales_cartera.suma_total_modulo_0a30 ?? 0}}</span>
								<span class="mb-1 fs-large">${{new Intl.NumberFormat().format(totales_cartera.suma_total_valor_modulo_0a30 ?? 0)}}</span>
							</div>
							<div class="flex align-items-end">
							
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 md:col-6 lg:col-2 mt-1">
					<div class="card overview-box flex flex-column pt-2 green-bgcolor solid-surface-text-color" style="background-color: #ffbd16 !important;">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">31 - 60 DIAS</h6>
							
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column">
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{totales_cartera.suma_total_modulo_31a60 ?? 0}}</span>
								<span class="mb-1 fs-large">${{new Intl.NumberFormat().format(totales_cartera.suma_total_valor_modulo_31a60 ?? 0)}}</span>
							</div>
							<div class="flex align-items-end">
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 md:col-6 lg:col-2 mt-1">
					<div class="card overview-box flex flex-column pt-2 orange-bgcolor solid-surface-text-color" style="background-color: #ff7722 !important;">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">61 - 90 DIAS</h6>
							
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column">
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{totales_cartera.suma_total_modulo_61a90 ?? 0}}</span>
								<span class="mb-1 fs-large">${{new Intl.NumberFormat().format(totales_cartera.suma_total_valor_modulo_61a90 ?? 0)}}</span>
							</div>
							<div class="flex align-items-end">
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 md:col-6 lg:col-2 mt-1">
					<div class="card overview-box flex flex-column pt-2 pink-bgcolor solid-surface-text-color" style="background-color: #f45b5b !important;height: fit-content;">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">MAYOR A 90 DIAS</h6>
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column">
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{totales_cartera.suma_total_modulo_mayor_90 ?? 0}}</span>
								<span class="mb-1 fs-large">${{new Intl.NumberFormat().format(totales_cartera.suma_total_valor_modulo_mayor_90 ?? 0)}}</span>
							</div>
							
						</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-4">
					<template v-if="selectgenerador!=null">
						<h5>{{name_generador}}</h5>
					</template>
					<template v-else>
						<h5>CARTERA</h5>
					</template>
					<Multiselect
							v-model="selectgenerador"
							placeholder="Seleccione Generador"
							:max="-1"
							valueProp="documento"
							:options="generadores"
							:searchable="true"
							label="razon_social"
							track-by="razon_social"
							@change="customer_selected1"
						/>
				</div>


			
			<div class="col-12 lg:col-12">
			<DataTable ref="pagination" :value="cartera_generadores" v-model:selection="selectedProducts" dataKey="id" :paginator="false" :rows="3" @paginate="onChangePage"
							:paginatorTemplate="'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'"
							:currentPageReportTemplate="'Showing '+pagination.from+' to '+pagination.to+' of '+pagination.total+' customers'" responsiveLayout="scroll">
					<Column field="sucursal_origina_descripcion" header="GENERADOR" :sortable="false" style="width: 400px;">
						<template #body="slotProps">
							<!-- <span class="p-column-title">generador</span> -->
							<strong>{{slotProps.data.razon_social}}</strong><br>{{'NIT '+slotProps.data.nit_generador}}
						</template>
					</Column>
					<Column field="venta_fecha" header="SIN VENCER" :sortable="false" class="">
						<template #body="slotProps">
							<span class="p-column-title">Fecha</span>
							<!-- <strong>SIN VENCER</strong><br> -->
							<div @click="showvalor(slotProps.data,1)" class="cursor-pointer">
								<!-- <Badge value="SIN VENCER" severity="success" size="large" class="mb-2 purple-bgcolor cursor-pointer" style="background-color: #77bf62 !important;"></Badge> -->
								<strong class="ml-1">{{'$'+new Intl.NumberFormat().format(slotProps.data.indicadores.modulo_sin_vencer.total_valor)}}</strong>
								<template v-if="slotProps.data.indicadores.modulo_sin_vencer.total > 0">
									<br>{{'Cantidad: '+slotProps.data.indicadores.modulo_sin_vencer.total}}
									<!-- <Badge severity="danger" :value="slotProps.data.indicadores.modulo_sin_vencer.total" style="position: absolute;transform-origin: 100% 0; margin: 0;"></Badge> -->
								</template>
							</div>
							
							<!-- <Badge :value="'$'+new Intl.NumberFormat().format(slotProps.data.indicadores.modulo_sin_vencer.total_valor)" severity="successu" size="large" class="mt-1 purple-bgcolor cursor-pointer" @click="showvalor(slotProps.data,1)"></Badge> -->
						</template>
					</Column>
					<Column field="venta_fecha" header="0 - 30 DIAS" :sortable="false" class="">
						<template #body="slotProps">
							<span class="p-column-title">Fecha</span>
							<!-- <strong>0 - 30 DIAS</strong><br>
							<Badge :value="'$'+new Intl.NumberFormat().format(slotProps.data.indicadores.modulo_0a30.total_valor)" severity="info" size="large" class="mt-1 cursor-pointer" @click="showvalor(slotProps.data,2)"></Badge> -->
							<div @click="showvalor(slotProps.data,2)" class="cursor-pointer">
								<!-- <Badge value="0 - 30 DIAS" severity="info" size="large" class="mb-1 cursor-pointer" style="background-color: #429ce5 !important;"></Badge> -->
								
								<strong class="ml-1">{{'$'+new Intl.NumberFormat().format(slotProps.data.indicadores.modulo_0a30.total_valor)}}</strong>
								<template v-if="slotProps.data.indicadores.modulo_0a30.total > 0">
									<br>{{'Cantidad: '+slotProps.data.indicadores.modulo_0a30.total}}
									<!-- <Badge severity="danger" :value="slotProps.data.indicadores.modulo_0a30.total" style="position: absolute;transform-origin: 100% 0; margin-top: -15px;"></Badge> -->
								</template>
							</div>
						</template>
					</Column>
					<Column field="venta_fecha" header="31 - 60 DIAS" :sortable="false" class="">
						<template #body="slotProps">
							<span class="p-column-title">Fecha</span>
							<!-- <strong>31 - 60 DIAS</strong><br>
							<Badge :value="'$'+new Intl.NumberFormat().format(slotProps.data.indicadores.modulo_31a60.total_valor)" severity="success" size="large" class="mt-1 cursor-pointer" @click="showvalor(slotProps.data,3)"></Badge> -->
							<div @click="showvalor(slotProps.data,3)" class="cursor-pointer">
								<!-- <Badge value="31 - 60 DIAS" severity="success" size="large" class="mb-1 cursor-pointer" style="background-color: #ffbd16 !important;"></Badge> -->
								
								<strong class="ml-1">{{'$'+new Intl.NumberFormat().format(slotProps.data.indicadores.modulo_31a60.total_valor)}}</strong>
								<template v-if="slotProps.data.indicadores.modulo_31a60.total > 0">
									<br>{{'Cantidad: '+slotProps.data.indicadores.modulo_31a60.total}}
									<!-- <Badge severity="danger" :value="slotProps.data.indicadores.modulo_31a60.total" style="position: absolute;transform-origin: 100% 0; margin-top: -15px;"></Badge> -->
								</template>
							</div>
						</template>
					</Column>
					<Column field="venta_fecha" header="61 - 90 DIAS" :sortable="false" class="">
						<template #body="slotProps">
							<span class="p-column-title">Fecha</span>
							<!-- <strong>61 - 90 DIAS</strong><br>
							<Badge :value="'$'+new Intl.NumberFormat().format(slotProps.data.indicadores.modulo_61a90.total_valor)" severity="warning" size="large" class="mt-1 cursor-pointer" @click="showvalor(slotProps.data,4)"></Badge> -->
							<div @click="showvalor(slotProps.data,4)" class="cursor-pointer">
								<!-- <Badge value="61 - 90 DIAS" severity="success" size="large" class="mb-1 cursor-pointer" style="background-color: #ff7722 !important;" ></Badge> -->
								
								<strong class="ml-1">{{'$'+new Intl.NumberFormat().format(slotProps.data.indicadores.modulo_61a90.total_valor)}}</strong>
								<template v-if="slotProps.data.indicadores.modulo_61a90.total > 0">
									<br>{{'Cantidad: '+slotProps.data.indicadores.modulo_61a90.total}}
									<!-- <Badge severity="danger" :value="slotProps.data.indicadores.modulo_61a90.total" style="position: absolute;transform-origin: 100% 0; margin-top: -15px;"></Badge> -->
								</template>
							</div>
						</template>
					</Column>
					<Column field="venta_fecha" header="MAYOR A 90 DIAS" :sortable="false" class="">
						<template #body="slotProps">
							<span class="p-column-title">Fecha</span>
							<div @click="showvalor(slotProps.data,5)" class="cursor-pointer">
								<strong class="ml-1">{{'$'+new Intl.NumberFormat().format(slotProps.data.indicadores.modulo_mayor_90.total_valor)}}</strong>
								<template v-if="slotProps.data.indicadores.modulo_mayor_90.total > 0">
									<br>Cantidad:<strong>{{slotProps.data.indicadores.modulo_mayor_90.total}}</strong>
								</template>
							</div>
						</template>
					</Column>
					<Column field="venta_fecha" header="TOTAL" :sortable="false" class="">
						<template #body="slotProps">
							<span class="p-column-title">Fecha</span>
							<!-- <div @click="showvalor(slotProps.data,5)" class="cursor-pointer"> -->
								<strong class="ml-1">{{'$'+new Intl.NumberFormat().format(sumar_cantidad_valor_individual(slotProps.data.indicadores))}}</strong>
								<!-- <template v-if="slotProps.data.indicadores.modulo_mayor_90.total > 0"> -->
									<!-- <br>Cantidad:<strong>{{slotProps.data.indicadores.modulo_mayor_90.total}}</strong> -->

									<br>Cantidad:<strong>{{sumar_cantidad_individual(slotProps.data.indicadores)}}</strong>
								<!-- </template> -->
							<!-- </div> -->
						</template>
					</Column>
					<template #paginatorstart>
						<!-- <Button type="button" icon="pi pi-refresh" /> -->
						<!-- <pagination v-model="pagination.current_page" ref="pagination" :records="pagination.total" :per-page="pagination.per_page" @paginate="onChangePage" style="background-color: aqua;"/> -->
					</template>
					<template #paginatorend>
						<!-- <Button type="button" icon="pi pi-cloud" /> -->
					</template>
				</DataTable>
				<div>
					<Paginator :v-model:first="pagination_generador.from" :rows="pagination_generador.per_page" :rowsPerPageOptions="[15]" :totalRecords="pagination_generador.total" @page="onChangePagecargar_empresas($event)"></Paginator>
				</div>
			</div>
		</template>
		<template v-else>
			
			<!-- <div class="col-12 md:col-6 lg:col-8"> -->
			<!-- <div class="grid p-fluid grid-container"> -->

				<div class="col-12 md:col-6 lg:col-2">
					<div class="card overview-box flex flex-column pt-2 bg-white border-blue-900 border-solid solid-blue-900-text-color text-blue-900">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">TOTAL</h6>
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column" >
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{total_indidcadores}}</span>
								<span class=" fs-large">${{new Intl.NumberFormat().format(total_valor_indidcadores)}}</span>
							</div>
							<div class="flex align-items-end">
							
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-2">
					<div class="card overview-box flex flex-column pt-2 purple-bgcolor solid-surface-text-color cursor-pointer" style="background-color: #77bf62 !important;" @click="selectindicador(1)">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">SIN VENCER</h6>
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column" >
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{sin_vencer}}</span>
								<span class="mb-1 fs-large">${{sin_vencer_valor}}</span>
							</div>
							<div class="flex align-items-end">
							
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-2">
					<div class="card overview-box flex flex-column pt-2 blue-bgcolor solid-surface-text-color cursor-pointer" style="background-color: #429ce5 !important;" @click="selectindicador(2)">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">0 - 30 DIAS</h6>
							<!-- <div :class="{'ml-auto': !isRTL, 'mr-auto': isRTL}">
								<Button icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text solid-surface-text-color"></Button>
								<Menu ref="menu" :popup="true" :model="items"></Menu>
							</div> -->
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column">
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{cuantos_0a30}}</span>
								<span class="mb-1 fs-large">${{cuantos_0a30_valor}}</span>
							</div>
							<div class="flex align-items-end">
							
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-2">
					<div class="card overview-box flex flex-column pt-2 green-bgcolor solid-surface-text-color cursor-pointer" style="background-color: #ffbd16 !important;" @click="selectindicador(3)">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">31 - 60 DIAS</h6>
							<!-- <div :class="{'ml-auto': !isRTL, 'mr-auto': isRTL}">
								<Button icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text solid-surface-text-color"></Button>
								<Menu ref="menu" :popup="true" :model="items"></Menu>
							</div> -->
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column">
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{cuantos_31a60}}</span>
								<span class="mb-1 fs-large">${{cuantos_31a60_valor}}</span>
							</div>
							<div class="flex align-items-end">
								<!-- <Chart ref="overviewChartData5" type="line" :data="overviewChartData5" :options="overviewChartOptions2" responsive="true" :height="60" :width="160"></Chart> -->
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-2">
					<div class="card overview-box flex flex-column pt-2 orange-bgcolor solid-surface-text-color cursor-pointer" style="background-color: #ff7722 !important;" @click="selectindicador(4)">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">61 - 90 DIAS</h6>
							<!-- <div :class="{'ml-auto': !isRTL, 'mr-auto': isRTL}">
								<Button icon="pi pi-ellipsis-h" class="p-button-rounded p-button-text solid-surface-text-color"></Button>
								<Menu ref="menu" :popup="true" :model="items"></Menu>
							</div> -->
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column">
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{cuantos_61a90}}</span>
								<span class="mb-1 fs-large">${{cuantos_61a90_valor}}</span>
							</div>
							<div class="flex align-items-end">
								<!-- <Chart ref="overviewChartData6" type="line" :data="overviewChartData6" :options="overviewChartOptions2" responsive="true" :height="60" :width="160"></Chart> -->
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 md:col-6 lg:col-2">
					<div class="card overview-box flex flex-column pt-2 pink-bgcolor solid-surface-text-color cursor-pointer" style="background-color: #f45b5b !important;height: fit-content;" @click="selectindicador(5)">
						<div class="flex align-items-center">
							<i class="pi pi-wallet"></i>
							<h6 class="m-0" :class="{'pl-2': !isRTL, 'pr-2': isRTL}">MAYOR A 90 DIAS</h6>
						</div>
						<div class="flex justify-content-between mt-3 flex-wrap">
							<div class="flex flex-column">
								<span class="font-medium text-white-900"><strong>CANTIDAD:</strong> {{cuantos_mas_90}}</span>
								<span class="mb-1 fs-large">${{cuantos_mas_90_valor}}</span>
							</div>
							<!-- <div class="flex align-items-end">
							
							</div> -->
						</div>
					</div>
				<!-- </div> -->
				<!-- </div> -->
			</div>
			<div class="col-12 md:col-6 lg:col-4">
				<template v-if="selectgenerador!=null">
					<!-- <h5>{{selectgenerador.razon_social}}</h5> -->
					<h5>{{name_generador}}</h5>
				</template>
				<template v-else>
					<h5>CARTERA</h5>
				</template>
					<!-- <Multiselect v-model="selectgenerador" placeholder="Seleccione Generador" :max="-1" valueProp="documento" :options="generadores" :searchable="true" label="razon_social" track-by="razon_social" @change="customer_selected"/> -->
					<Multiselect
						v-model="selectgenerador"
						placeholder="Seleccione Generador"
						:max="-1"
						valueProp="documento"
						:options="generadores"
						:searchable="true"
						label="razon_social"
						track-by="razon_social"
						@change="customer_selected1"
					/>
			</div>

			<div class="col-6 lg:col-2 mt-4" v-show="detalle_cartera.length >= 1">
				<Dropdown v-model="campo_selected" :showClear="true" :options="campos_tabla" optionLabel="name" optionValue="code" placeholder="Filtrar por" class="mr-2" />
			</div>
			<template v-if="campo_selected=='num_factura'">
				<div class="col-6 lg:col-3 mt-4">
					
					<InputText placeholder="Núm Factura" v-model="text_filter" required="true" autofocus type="number" />
				</div>
			</template>
			<template v-if="campo_selected=='fecha_venta' || campo_selected=='fecha_vencimiento'">
				
				
					<template v-if="frmfiltros.rangofechasolicitud">
						<div class="col-6 lg:col-2" style="height: fit-content;">
							<Checkbox id="checkrangofechasolicitud" :binary="true" v-model="frmfiltros.rangofechasolicitud" class="mb-1 mr-1 ml-5"></Checkbox>
							<label for="checkrangofechasolicitud">Rango</label>
							<!-- <Calendar id="range" v-model="text_filter" selectionMode="range" :showIcon="true" :locale="es" :manualInput="false" placeholder="Fecha inicial" /> -->
							<Calendar v-model="text_filter" :showTime="false" :showIcon="true" :locale="es" class="ml-2" placeholder="Fecha inicial" />
						</div>
						<div class="col-12 lg:col-2  lg:mt-4">
							<Calendar v-model="frmfiltros.fechasolicitudrango" :minDate="text_filter" :showTime="false" :showIcon="true" :locale="es" class=" lg:ml-3" placeholder="Fecha final"/>
						</div>
					</template>
					<template v-else>
						<div class="col-6 lg:col-2" style="height: fit-content;">
							<Checkbox id="checkrangofechasolicitud" :binary="true" v-model="frmfiltros.rangofechasolicitud" class="mb-1 mr-1 ml-5"></Checkbox>
							<label for="checkrangofechasolicitud">Rango</label>
							<Calendar v-model="text_filter" :showTime="false" :showIcon="true" :locale="es" placeholder="Fecha"/>
						</div>
					</template>
			</template>
		<template v-if="campo_selected!=null">
			<div class="col-12 lg:col-3">
				<div class="grid mt-3">
					<div class="p-fluid col-6">
						<Button type="button" class="p-button-raised mb-1" label="Buscar" icon="pi pi-search" :loading="loading[0]" @click="load(0,1)" />
					</div>
					<div class="p-fluid col-6">
						<Button type="button" class="p-button-raised" label="Limpiar" icon="pi pi-filter-slash" :loading="loading[0]" @click="limpiar" />
					</div>
				</div>
			</div>
		</template>

			<div class="col-12 lg:col-12" v-show="detalle_cartera.length >= 1">
				<DataTable ref="pagination" :value="detalle_cartera" v-model:selection="selectedProducts" dataKey="id" :paginator="false" :rows="3" @paginate="onChangePage"
							:paginatorTemplate="'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'" 
							:currentPageReportTemplate="'Showing '+pagination.from+' to '+pagination.to+' of '+pagination.total+' customers'" responsiveLayout="scroll">
					<template #header>
					</template>
					<!-- <Column field="select_factura" selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
					<Column field="venta_numero" header="Nro. Factura" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">Nro. Factura</span>
							{{slotProps.data.venta_numero}}
						</template>
					</Column>
					<Column field="venta_fecha" header="Fecha Factura" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">Fecha</span>
							{{slotProps.data.venta_fecha}}
						</template>
					</Column>
					<Column field="venta_vence" header="Fecha Vence" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">Vence</span>
							{{slotProps.data.venta_vence}}
						</template>
					</Column>
					<Column field="venta_plazo" header="Plazo" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">Plazo</span>
							{{slotProps.data.venta_plazo}}
						</template>
					</Column>
					<Column field="dias_cartera" header="Días Cartera" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">Dias Cartera</span>
							{{slotProps.data.dias_cartera}} días
						</template>
					</Column>
					<Column field="dias_vencido" header="Días Vencido" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">Dias Vencido</span>
							<template v-if="slotProps.data.dias_vencido < 0">
								0
							</template>
							<template v-else>
							{{slotProps.data.dias_vencido}} días
							</template>
						</template>
					</Column>
					<Column field="venta_total" header="Valor Factura" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">Valor Factura</span>
							${{new Intl.NumberFormat().format(slotProps.data.venta_total)}}
						</template>
					</Column>
					<Column field="venta_abonos" header="Valor Abonado" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">Valor Abonado</span>
							${{new Intl.NumberFormat().format(slotProps.data.venta_abonos)}}
						</template>
					</Column>
					<Column field="venta_saldo" header="Valor Saldo" :sortable="false">
						<template #body="slotProps">
							<span class="p-column-title">Valor Saldo</span>
							${{calcular_saldo(slotProps.data.venta_total,slotProps.data.venta_abonos)}}
						</template>
					</Column>
					<Column field="generador_nombre" :sortable="false">
						<template #body="slotProps">
							<template v-if="slotProps.data.pagado > 0">
								<Button icon="pi pi-eye" class="p-button-rounded p-button-primary p-button-outlined m-1" :loading="loader" title="Ver Detalle del Ultimo Pago" @click="openModalDetallePago(slotProps.data)" />
							</template>
						</template>
					</Column>
					<template #paginatorstart>
					
					</template>
					<template #paginatorend>
						
					</template>
				</DataTable>
				<div>
					<Paginator :v-model:first="pagination.from" :rows="pagination.per_page" :rowsPerPageOptions="[10]" :totalRecords="pagination.total" @page="onChangePage($event)"></Paginator>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
// import axios from 'axios'
export default {
	data() {
		return {
			message: [],
			customers: [],
			cartera_generadores: [],
			username:null,
			campos_tabla: [
				{name: 'Fecha Venta', code: 'fecha_venta'},
				{name: 'Fecha Vencimiento', code: 'fecha_vencimiento'},
				{name: 'Número Factura', code: 'num_factura'}
			],
			selectgenerador: null,
			generadores: [],
			totales_cartera: [],
			// totales_cartera: {
			// 	suma_total_modulo_0a30: 0,
			// 	suma_total_modulo_31a60: 0,
			// 	suma_total_modulo_61a90: 0,
			// 	suma_total_modulo_mayor_90: 0,
			// 	suma_total_modulo_sin_vencer: 0,
			// 	suma_total_valor_modulo_0a30: 0,
			// 	suma_total_valor_modulo_31a60: 0,
			// 	suma_total_valor_modulo_61a90: 0,
			// 	suma_total_valor_modulo_mayor_90: 0,
			// 	suma_total_valor_modulo_sin_vencer: 0
			// },
			loading: [false, false, false],
			text_filter: '',
			campo_selected: null,
			detalle_cartera: [],
			name_generador: '',
			nit_customer: '',
			loader: false,
			load_indicadores: false,
			email:null,
			//0 a 30 dias
			cuantos_0a30: 0,
			cuantos_0a30_valor: 0,
			detalle_0a30: [],
			//31 a 60 dias
			cuantos_31a60: 0,
			cuantos_31a60_valor: 0,
			detalle_31a60: [],
			//61 a 90 dias
			cuantos_61a90: 0,
			cuantos_61a90_valor: 0,
			detalle_61a90: [],
			//más de 90 dias
			cuantos_mas_90: 0,
			cuantos_mas_90_valor: 0,
			detalle_mas_90: [],
			//sin vencer
			sin_vencer: 0,
			sin_vencer_valor: 0,
			detalle_sin_vencer: [],
			cartera: 0,
			centro_costos: [],
			total_indidcadores: 0,
			total_valor_indidcadores: 0,
			paginador_mas_90: {},
			paginador_61a90: {},
			frmfiltros: {
                fechasolicitud: '',
                rangofechasolicitud: false,
                fechasolicitudrango: '',
            },
			paginador_31a60: {},
			paginador_0a30: {},
			pagination: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
			pagination_generador: {
				current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0
			},
			count: 0,
			selectedProducts: null,
			items: [
					{label: 'Update', icon: 'pi pi-fw pi-refresh'},
					{label: 'Edit', icon: 'pi pi-fw pi-pencil'}
				],
			ingresoCostumer: false
		}
	},
	mounted(){
		this.cargar_empresas(1);
	},
	methods:{
		traerindicadores(data){
			if(data){
				// console.log(data);
				this.cargar_empresas(data);
			}else{
				console.log('deseleccionado');
			}
		},
		suma_cartera(data){
			var total_cant = 0;
			total_cant = (data.suma_total_modulo_sin_vencer ?? 0) +
						(data.suma_total_modulo_0a30 ?? 0) +
						(data.suma_total_modulo_31a60 ?? 0) +
						(data.suma_total_modulo_61a90 ?? 0) +
						(data.suma_total_modulo_mayor_90 ?? 0);
						
			return total_cant;
		},
		suma_cartera_valor(data){
			var total_cant = 0;
			total_cant = parseInt(data.suma_total_valor_modulo_sin_vencer ?? 0) +
						parseInt(data.suma_total_valor_modulo_0a30 ?? 0) +
						parseInt(data.suma_total_valor_modulo_31a60 ?? 0) +
						parseInt(data.suma_total_valor_modulo_61a90 ?? 0) +
						parseInt(data.suma_total_valor_modulo_mayor_90 ?? 0);
						
			return total_cant;
		},
		sumar_cantidad_individual(data){
			var total_cant = 0;
			total_cant = (data.modulo_sin_vencer.total ?? 0) +
						(data.modulo_0a30.total ?? 0) +
						(data.modulo_31a60.total ?? 0) +
						(data.modulo_61a90.total ?? 0) +
						(data.modulo_mayor_90.total ?? 0);
						
			return total_cant;
		},
		sumar_cantidad_valor_individual(data){
			var total_cant = 0;
			total_cant = parseInt(data.modulo_sin_vencer.total_valor ?? 0) +
						parseInt(data.modulo_0a30.total_valor ?? 0) +
						parseInt(data.modulo_31a60.total_valor ?? 0) +
						parseInt(data.modulo_61a90.total_valor ?? 0) +
						parseInt(data.modulo_mayor_90.total_valor ?? 0);
						
			return total_cant;
		},
		cargar_empresas(page){
			const cookieName = 'Email';
			const IdRol = 'IdRol';
			this.loader = true;
			this.customers = [];
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			this.cartera_generadores = [];
			var email = cookie[cookieName];
			var id_rol = cookie[IdRol];
			var _that = this;
                window.api.call('post', '/cargar_cartera_empresa_transporte?&page='+page, {email: email,id_rol: id_rol}).then( function(response) {
                    if(response.status == 200){
						_that.cartera_generadores = response.data.data.data;
						_that.pagination_generador = response.data.data;
						_that.generadores = response.data.generadores;
						_that.nit_customer = response.data.nit_customer;
						_that.totales_cartera = response.data.totales;
						_that.cartera_generadores.forEach(element => {
							element.indicadores = JSON.parse(element.json_indicadores_cartera)
							// console.log(JSON.parse(element.json_indicadores_cartera));
						});
						// console.log(response.data.data);
						
						_that.loader = false;
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
                });
		},
		showvalor(data,indicador){
			console.log(indicador);
			console.log(data);
			this.generadores.forEach(element => {
				if (element.documento == data.nit_generador) {
			// 	// 	console.log(element.document);
					this.name_generador = data.razon_social;
					this.nit_customer = data.nit_customer;
					this.selectgenerador = element.documento;
					//0 a 30 dias
					this.cuantos_0a30 = data.indicadores.modulo_0a30.total;
					this.cuantos_0a30_valor = new Intl.NumberFormat().format(data.indicadores.modulo_0a30.total_valor);

					//31 a 60 dias
					this.cuantos_31a60 = data.indicadores.modulo_31a60.total;
					this.cuantos_31a60_valor = new Intl.NumberFormat().format(data.indicadores.modulo_31a60.total_valor);

					//61 a 90 dias
					this.cuantos_61a90 = data.indicadores.modulo_61a90.total;
					this.cuantos_61a90_valor = new Intl.NumberFormat().format(data.indicadores.modulo_61a90.total_valor);

					//más de 90 dias
					this.cuantos_mas_90 = data.indicadores.modulo_mayor_90.total;
					this.cuantos_mas_90_valor = new Intl.NumberFormat().format(data.indicadores.modulo_mayor_90.total_valor);

					//sin vencer
					this.sin_vencer = data.indicadores.modulo_sin_vencer.total;
					this.sin_vencer_valor = new Intl.NumberFormat().format(data.indicadores.modulo_sin_vencer.total_valor);

					this.total_valor_indidcadores = 
						parseInt(data.indicadores.modulo_sin_vencer.total_valor ?? 0) +
						parseInt(data.indicadores.modulo_0a30.total_valor ?? 0) +
						parseInt(data.indicadores.modulo_31a60.total_valor ?? 0) +
						parseInt(data.indicadores.modulo_61a90.total_valor ?? 0) +
						parseInt(data.indicadores.modulo_mayor_90.total_valor ?? 0);

					this.total_indidcadores = 
						parseInt(data.indicadores.modulo_sin_vencer.total ?? 0) +
						parseInt(data.indicadores.modulo_0a30.total ?? 0) +
						parseInt(data.indicadores.modulo_31a60.total ?? 0) +
						parseInt(data.indicadores.modulo_61a90.total ?? 0) +
						parseInt(data.indicadores.modulo_mayor_90.total ?? 0);
				}
			});
			//  = data;
			this.selectindicador(indicador);
		},
		calcular_saldo(valor_factura, abono){
			var total_pagar = parseInt(valor_factura)-parseInt(abono);
			return new Intl.NumberFormat().format(total_pagar);
		},
		selectindicador(indicador){
			// console.log(indicador);
			// this.cleartable();
			switch (indicador) {
				case 1:
						this.cartera = 1;
					break;
				case 2:
						this.cartera = 2;
					break;
				case 3:
						this.cartera = 3;
					break;
				case 4:
						this.cartera = 4;
					break;
				case 5:
						this.cartera = 5;
					break;
				default:
					break;
			}
			const page = {};
			page.page = 0;
			this.onChangePage(page);
		},
		customer_selected1(newValue, oldValue) {
			// Comparar si se ha seleccionado algo
			if (newValue && !oldValue) {
				// Acción a realizar solo cuando se selecciona algo
				console.log('Elemento seleccionado:', newValue);
				this.detalle_cartera = [];
				this.cuantos_0a30 = 0;
				this.cuantos_0a30_valor = new Intl.NumberFormat().format(0);

				this.cuantos_31a60 = 0;
				this.cuantos_31a60_valor = new Intl.NumberFormat().format(0);

				this.cuantos_61a90 = 0;
				this.cuantos_61a90_valor = new Intl.NumberFormat().format(0);

				this.cuantos_mas_90 = 0;
				this.cuantos_mas_90_valor = 0;

				this.sin_vencer = 0;
				this.sin_vencer_valor = new Intl.NumberFormat().format(0);

				this.total_indidcadores = 0;
				this.total_valor_indidcadores = new Intl.NumberFormat().format(0);
				
				this.loader = true;
				var _that = this;
				var json_indicadores_cartera = [];
                window.api.call('post', '/cargar_indicadores_generador', {nit_generador: newValue,nit_customer: this.nit_customer}).then( function(response) {
                    if(response.status == 200){
						if (response.data.data!=null) {
							_that.name_generador = response.data.data.razon_social;
							// data.razon_social = response.data.data.razon_social;
							json_indicadores_cartera = JSON.parse(response.data.data.json_indicadores_cartera)
							console.log(json_indicadores_cartera);
							_that.cuantos_0a30 = json_indicadores_cartera.modulo_0a30.total;
							_that.cuantos_0a30_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_0a30.total_valor ?? 0);

							_that.cuantos_31a60 = json_indicadores_cartera.modulo_31a60.total;
							_that.cuantos_31a60_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_31a60.total_valor ?? 0);

							_that.cuantos_61a90 = json_indicadores_cartera.modulo_61a90.total;
							_that.cuantos_61a90_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_61a90.total_valor ?? 0);

							_that.cuantos_mas_90 = json_indicadores_cartera.modulo_mayor_90.total;
							_that.cuantos_mas_90_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_mayor_90.total_valor ?? 0);

							_that.sin_vencer = json_indicadores_cartera.modulo_sin_vencer.total;
							_that.sin_vencer_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_sin_vencer.total_valor ?? 0);

							_that.total_valor_indidcadores = 
								parseInt(json_indicadores_cartera.modulo_sin_vencer.total_valor ?? 0) +
								parseInt(json_indicadores_cartera.modulo_0a30.total_valor ?? 0) +
								parseInt(json_indicadores_cartera.modulo_31a60.total_valor ?? 0) +
								parseInt(json_indicadores_cartera.modulo_61a90.total_valor ?? 0) +
								parseInt(json_indicadores_cartera.modulo_mayor_90.total_valor ?? 0);

							_that.total_indidcadores = 
								parseInt(json_indicadores_cartera.modulo_sin_vencer.total ?? 0) +
								parseInt(json_indicadores_cartera.modulo_0a30.total ?? 0) +
								parseInt(json_indicadores_cartera.modulo_31a60.total ?? 0) +
								parseInt(json_indicadores_cartera.modulo_61a90.total ?? 0) +
								parseInt(json_indicadores_cartera.modulo_mayor_90.total ?? 0);
						}
						
						// _that.detalle_cartera = response.data.data.json_indicadores_cartera;
						// _that.pagination = response.data.data;
						
						_that.loader = false;
						// _that.search_paginador = false;
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
                });

			}
    	},
		customer_selected() {

			console.log(this.selectgenerador);
			
			
			if (this.selectgenerador!=null) {
				this.detalle_cartera = [];
				this.cuantos_0a30 = 0;
				this.cuantos_0a30_valor = new Intl.NumberFormat().format(0);

				this.cuantos_31a60 = 0;
				this.cuantos_31a60_valor = new Intl.NumberFormat().format(0);

				this.cuantos_61a90 = 0;
				this.cuantos_61a90_valor = new Intl.NumberFormat().format(0);

				this.cuantos_mas_90 = 0;
				this.cuantos_mas_90_valor = 0;

				this.sin_vencer = 0;
				this.sin_vencer_valor = new Intl.NumberFormat().format(0);
				this.loader = true;
				var _that = this;
				var json_indicadores_cartera = [];
                window.api.call('post', '/cargar_indicadores_generador', {nit_generador: this.selectgenerador,nit_customer: this.nit_customer}).then( function(response) {
                    if(response.status == 200){
						_that.name_generador = response.data.data.razon_social;
						// data.razon_social = response.data.data.razon_social;
						json_indicadores_cartera = JSON.parse(response.data.data.json_indicadores_cartera)
						console.log(json_indicadores_cartera);
						_that.cuantos_0a30 = json_indicadores_cartera.modulo_0a30.total;
						_that.cuantos_0a30_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_0a30.total_valor ?? 0);

						_that.cuantos_31a60 = json_indicadores_cartera.modulo_31a60.total;
						_that.cuantos_31a60_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_31a60.total_valor ?? 0);

						_that.cuantos_61a90 = json_indicadores_cartera.modulo_61a90.total;
						_that.cuantos_61a90_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_61a90.total_valor ?? 0);

						_that.cuantos_mas_90 = json_indicadores_cartera.modulo_mayor_90.total;
						_that.cuantos_mas_90_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_mayor_90.total_valor ?? 0);

						_that.sin_vencer = json_indicadores_cartera.modulo_sin_vencer.total;
						_that.sin_vencer_valor = new Intl.NumberFormat().format(json_indicadores_cartera.modulo_sin_vencer.total_valor ?? 0);
						// _that.detalle_cartera = response.data.data.json_indicadores_cartera;
						// _that.pagination = response.data.data;
						
						_that.loader = false;
						// _that.search_paginador = false;
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
                });
				// this.generadores.forEach(element => {
				// var data =  this.cartera_generadores.find((generador) => generador.nit_generador == this.selectgenerador)
				// console.log(data);
				// this.name_generador = data.razon_social;
				// // this.nit_customer = data.nit_customer;

				// this.cuantos_0a30 = data.indicadores.modulo_0a30.total;
				// this.cuantos_0a30_valor = new Intl.NumberFormat().format(data.indicadores.modulo_0a30.total_valor ?? 0);

				// //31 a 60 dias
				// this.cuantos_31a60 = data.indicadores.modulo_31a60.total;
				// this.cuantos_31a60_valor = new Intl.NumberFormat().format(data.indicadores.modulo_31a60.total_valor ?? 0);

				// //61 a 90 dias
				// this.cuantos_61a90 = data.indicadores.modulo_61a90.total;
				// this.cuantos_61a90_valor = new Intl.NumberFormat().format(data.indicadores.modulo_61a90.total_valor ?? 0);

				// //más de 90 dias
				// this.cuantos_mas_90 = data.indicadores.modulo_mayor_90.total;
				// this.cuantos_mas_90_valor = new Intl.NumberFormat().format(data.indicadores.modulo_mayor_90.total_valor ?? 0);

				// //sin vencer
				// this.sin_vencer = data.indicadores.modulo_sin_vencer.total;
				// this.sin_vencer_valor = new Intl.NumberFormat().format(data.indicadores.modulo_sin_vencer.total_valor ?? 0);
				// this.valor_seleccionado_facturas = 0;
				// this.abonos = [];
				// this.cargar_indicadores();
				// this.load_indicadores = true;
				// this.cartera_generadores = [];
			}else{

			}
		},
		cleartable(){
			// this.cartera_generadores = [];
			this.pagination.current_page = 0;
				this.pagination.from= 0;
				this.pagination.last_page= 0;
				this.pagination.per_page= 0;
				this.pagination.to= 0;
				this.pagination.total= 0;
		},
		onChangePagecargar_empresas(page) {
				
				this.cargar_empresas((page.page+1));
		},
		onChangePage(page) {
				
				this.loadDataTable1((page.page+1),this.cartera);
		},
		loadDataTable1(page,cartera){
			// this.cleartable();
			this.detalle_cartera = [];
			this.loader = true;
			var _that = this;
                window.api.call('post', '/cargar_cartera?&page='+page, {cartera: cartera,nit_generador: this.selectgenerador,nit_customer: this.nit_customer}).then( function(response) {
                    if(response.status == 200){
						_that.detalle_cartera = response.data.data.data;
						_that.pagination = response.data.data;
						
						_that.loader = false;
						_that.search_paginador = false;
                    }
                }).catch(function (err) {
                    console.log(err);
					_that.loader = false;
                });
		},
		load(index,page) {
			if(this.campo_selected==null){
				this.$toast.add({severity:'error', summary: 'Falta información', detail:'Favor seleccionar un campo e ingresar texto a filtrar', life: 4000});
			}else{
				if(this.campo_selected=='fecha_venta' && this.text_filter==''){
					this.$toast.add({severity:'error', summary: 'Falta fecha', detail:'Favor seleccionar una fecha a filtrar', life: 4000});

				}else{
					if(this.frmfiltros.rangofechasolicitud==true && this.frmfiltros.fechasolicitudrango==''){
						console.log(this.text_filter);
						this.$toast.add({severity:'error', summary: 'Falta información', detail:'Favor seleccionar una fecha inicio y una fecha fin a filtrar', life: 4000});
					}else{
						this.loading[index] = true;
						// this.cleartable();
						this.detalle_cartera = [];
						this.pagination.current_page = 0;
						this.pagination.from= 0;
						this.pagination.last_page= 0;
						this.pagination.per_page= 0;
						this.pagination.to= 0;
						this.pagination.total= 0;
						this.loader = true;
						var _that = this;
						let text = '';
						text = this.text_filter;
							window.api.call('post', '/filtrar_cartera_generador?&page='+page, {cartera: this.cartera,nit_generador: this.select_proveedor.documento,nit_customer: this.select_proveedor.document,nom_campo: this.campo_selected,text: text,rango: this.frmfiltros.rangofechasolicitud,fecha_fin: this.frmfiltros.fechasolicitudrango}).then( function(response) {
								if(response.status == 200){
									_that.detalle_cartera = response.data.data.data;
									_that.pagination = response.data.data;
									_that.loader = false;
									_that.loading[index] = false;
									_that.search_paginador = true;
								}
							}).catch(function (err) {
								console.log(err);
								_that.loader = false;
								_that.loading[index] = false;
							});
					}
				}
				
			}
		},
		salirCustomer(){
			this.ingresoCostumer = false;
		},
	},
	computed: {
			isRTL() {
				return this.$appState.RTL;
			}
		}
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 5 columnas iguales */
  gap: 10px; /* Espacio entre elementos */
}
.grid-item {
  /* padding: 20px; */
  border: 1px solid #ccc; /* Borde para cada div */
  text-align: center;
}
</style>
